//-- Copyright (c) 2021 TMT Insights Group, LLC
import { JobDetails, TitleBar } from '@tmt-insights/oms_fe_core';

const jobDetails: JobDetails = {
  titleBar: (): TitleBar[] => []
};

export default jobDetails;
